import { useParams } from 'react-router-dom';
import moment from 'moment';

import { Error } from '@/components/ui/error';
import { Loading } from '@/components/ui/loading';
import { useUsers } from '@/data/user';
import { useRoles } from '@/data/role';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';

const Users = () => {
  const params = useParams();
  const users = useUsers(params.companyUid);
  const roles = useRoles(params.companyUid);

  if ((users.isLoading && !users.data) || (roles.isLoading && !roles.data)) {
    return <Loading />;
  }

  if (users.error) {
    return <Error message="An error occurred loading company users" />;
  }

  if (roles.error) {
    return <Error message="An error occurred loading company roles" />;
  }

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Users</h2>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>User</TableHead>
            <TableHead>Created</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Role</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {users.data.query.map((userUid) => {
            const user = users.data.content[userUid];
            // A user with no role_uid — or one pointing at a since-deleted role — reads as "None".
            const role = user.role_uid ? roles.data.content[user.role_uid] : null;
            return (
              <TableRow key={userUid}>
                <TableCell className="font-medium">
                  {user.firstname} {user.lastname}
                </TableCell>
                <TableCell>{moment(user.create_ts).format('MMM Do, YYYY')}</TableCell>
                <TableCell>{user.username}</TableCell>
                <TableCell>{role ? <Badge variant="outline">{role.label}</Badge> : <span className="text-muted-foreground">None</span>}</TableCell>
                <TableCell>
                  <div className="flex gap-2">
                    {user.deleted && <Badge variant="outline">Deleted</Badge>}
                    {user.disabled && <Badge variant="outline">Disabled</Badge>}
                    {!user.deleted && !user.disabled && <Badge variant="secondary">Active</Badge>}
                  </div>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default Users;
